var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon Filter"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1838",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4217",
    d: "M17.472 3.417a.871.871 0 0 0-.672-1.419H2.87a.87.87 0 0 0-.805.544.818.818 0 0 0-.065.326.87.87 0 0 0 .2.553l.55.672 3.1 3.79 1.969 2.393a.87.87 0 0 1 .27.642v5.88a.869.869 0 0 0 1.373.709l.052-.039 1.669-1.253.048-.035a.87.87 0 0 0 .339-.688v-4.573a.87.87 0 0 1 .268-.629l1.971-2.406 3.655-4.463z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.585517b2ff07733f31da4a2012cc06f3.svg";
export { ForwardRef as ReactComponent };